export default "__VITE_ASSET__CqfuloAz__"